import { Box, BoxProps } from '@mui/material'
import { FC } from 'react'

export type ContentFrameProps = BoxProps & { contentWidth?: number | string }

/**
 * @description
 * コンテンツの表示領域を上限付きで画面横幅に合わせる
 * 上限を超過した場合は上限値に合わせて画面中央にコンテンツを配置する
 * 背景は画面横幅または親要素横幅に合わせたいが、中のコンテンツの表示横幅のみ制限したい場合に使用する
 *
 * @param children： コンテンツ
 * @param contentWidth：コンテンツの表示領域の上限横幅
 * @param props：BoxProps
 */
export const ContentFrame: FC<ContentFrameProps> = ({
  children,
  contentWidth = '1120px',
  ...props
}) => {
  const { sx, ...rest } = props
  return (
    <Box
      {...rest}
      sx={{
        width: '100%',
        maxWidth: contentWidth,
        mx: 'auto',
        ...(sx as {}),
      }}
    >
      {children}
    </Box>
  )
}
